import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import {inject, observer} from "mobx-react";
import K from '../../../../constants'
import { api } from '../../../../services';
import {message} from "antd";
import Section from "../../../../common/components/Section";
import rollbar from '../../../../services/rollbar';

@withRouter
@inject('leonardoStore', 'mypageStore', 'productsStore', 'translationsStore')
@observer
class SlimpayIframe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      success: false,
      iframeContent: null,
      hasConfirmedAgreement: false
    }
  }

  isOptionalAssistance = () => {
    const { productsStore } = this.props;
    const { optionalServiceProduct } = productsStore;

    return optionalServiceProduct
        ? productsStore.isAssistance(optionalServiceProduct)
        : false;
  };

  componentDidMount() {
    api('getSlimpayIframe', this.props.mypageStore.remoteUserData.uuid)
      .then(result => {
        this.setState({
          loading: false,
          iframeContent: result.iframe
        }, () => {

            this.props.onIframeLoaded?.();
            
            this.socket = new WebSocket(`wss://${K.API_URL.split("//")[1]}`);

            this.socket.addEventListener("open", event => {
                this.socket.send(JSON.stringify({type: "salutation", message: {id: this.props.mypageStore.remoteUserData.zuora_account_id}}));
            });

            this.socket.addEventListener("message", event => {
                try {
                this.onNotification(event.data)
                } catch (e) {
                console.error("error parsing data!");
                rollbar.error("Error parsing Slimpay notification data", e);
                }
            });
        })
      })
  }

  onNotification = async (data) => {
    try {
      const { leonardoStore } = this.props;
      await leonardoStore.subscribeToProduct('SEPA');
      this.props.onPaymentResult(true); 
    } catch (error) {
      console.error("Error during Slimpay notification handling", error);
      rollbar.error("Error during Slimpay notification handling", error);
      this.showErrorMessage();
      this.props.onPaymentResult(false);
    }
  };


  componentWillUnmount() {
    this.socket && this.socket.close();
  }

  showErrorMessage = () => {
    const { translationsStore } = this.props;
    message.error(translationsStore.translate('common.genericError'));
  };

  render() {
    return (
        (this.props.hasSubmittedSepaAgreement)?
            <Section
                className="SlimpayIframeContainer"
            >
                <div
                className="SlimpayIframe"
                dangerouslySetInnerHTML={{ __html: this.state.iframeContent}}
                height={600}
                />
            </Section>
        :
        <div/>
    )
  }
}

export default SlimpayIframe;
